import { Resources } from "web_myplann/Infrastructure/Translations/Resources";
import {
	type NormalizedTool,
	ToolKind,
} from "web_myplann/Portfolio/Helpers/investmentToolTypes";
import type { TranslateFunction } from "web_myplann/Shared/TranslateFunction";

export const getCryptoHoldingTypeLabel = (
	tool: NormalizedTool,
	t: TranslateFunction,
): string | null => {
	if (tool.kind !== ToolKind.Crypto) {
		return null;
	}
	const holdingType = tool.raw.holdingType;
	return holdingType
		? t(
				Resources.PortfolioDetail.ToolHistory.Cryptocurrency.HoldingType[
					holdingType
				],
			)
		: null;
};
